export default __webpack_public_path__ + "static/media/ISKO CLASS-4 EXAM PATTERN 2025.111c229b.pdf";